export default __webpack_public_path__ + "yVNB-Dm-tool.svg";